// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout__Sn5A6"};